/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { useAppDispatch } from "store";
import { layoutStateChanged } from "store/features";
import { LayoutState } from "types";
import { SandboxView } from "views/sandbox/SandboxView";

export const SandboxEmbedView = () => {
  const dispatch = useAppDispatch();
  const layout: LayoutState = {
    mainHeader: false,
  }

  dispatch(layoutStateChanged(layout));

  return <SandboxView />
};